<script setup lang="ts">
  import { computed } from 'vue';

  import type { Invoice } from '@stuut/api/models';
  import { InvoiceStatus } from '@stuut/api/models';

  interface Props {
    invoice: Invoice;
  }

  const props = defineProps<Props>();

  const invoiceLabel = computed(() => {
    const invoice = props.invoice;

    if (!invoice?.status) return;

    switch (props.invoice.status) {
      case InvoiceStatus.OPEN:
        return props.invoice.isOverdue ? 'overdue' : 'due';
      default:
        return props.invoice.status;
    }
  });

  const invoiceLabelClass = computed(() => {
    if (!props.invoice?.status) return;

    switch (props.invoice.status) {
      case InvoiceStatus.OPEN:
        return props.invoice.isOverdue ? 'text-error' : 'text-blue';
      case InvoiceStatus.PAID:
        return 'text-green';
      case InvoiceStatus.UNCOLLECTIBLE:
        return 'text-warning';
      case InvoiceStatus.VOID:
        return 'text-error';
      default:
        return '';
    }
  });
</script>

<template>
  <span :class="invoiceLabelClass" class="capitalize font-bold">
    {{ invoiceLabel }}

    <span v-if="props.invoice?.daysOverdue" class="text-destructive">
      {{ props.invoice?.daysOverdue }}
    </span>

    <span v-else-if="props.invoice?.daysUntilDue" class="text-blue">
      {{ props.invoice?.daysUntilDue }}
    </span>
  </span>
</template>

<style scoped></style>
